import { render } from "./SearchTagList.vue?vue&type=template&id=533f4d68&ts=true"
import script from "./SearchTagList.vue?vue&type=script&lang=ts"
export * from "./SearchTagList.vue?vue&type=script&lang=ts"

import "./SearchTagList.vue?vue&type=style&index=0&id=533f4d68&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__